import { render, staticRenderFns } from "./InquiryProtocol.vue?vue&type=template&id=96f75a30&scoped=true&"
var script = {}
import style0 from "./InquiryProtocol.vue?vue&type=style&index=0&id=96f75a30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f75a30",
  null
  
)

export default component.exports